enum OverviewPageType {
  PRODUCT = 'product-overview',
  ARTICLE = 'article-overview',
}

export { OverviewPageType };
